// AUTO-GENERATED — do not edit manually, run npm run icons
import { SvgIcon, type SvgIconProps } from '@mui/material';
import Svg from '@assets/icons/unlock.svg?react';

export const UnlockIcon = (props: SvgIconProps) => (
  <SvgIcon component={Svg} inheritViewBox {...props} />
);
